import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

/**
 * FallbackRoute component that redirects to the appropriate route based on the current path
 * If the path is '/', it redirects to the homepage with the current language code
 * Otherwise, it redirects to the 404 page with the current language code
 * @returns {JSX.Element} Navigate component that redirects to the appropriate route
 */
const FallbackRoute = () => {
  const { selectedLanguageCode } = useSelector((state) => state.language)
  const location = useLocation()

  // Default to 'en' if no language code is found
  const languageCode = selectedLanguageCode?.toLowerCase() || 'en'

  // If the path is '/', redirect to the homepage with the current language code
  if (location.pathname === '/') {
    return <Navigate to={`/${languageCode}`} replace />
  }

  // Otherwise, redirect to the 404 page with the current language code
  return <Navigate to={`/${languageCode}/404`} replace />
}

export default FallbackRoute
